exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome{min-height:calc(100vh - 191px);padding:5rem 0;display:flex;flex-direction:column;align-items:center}.welcomTitle{width:115px;height:37px;font-family:NanumBarunGothicOTF;font-size:32px;text-align:center}.loadMap{width:400px;height:72px;object-fit:contain}.congratulation{width:281px;height:278px;object-fit:contain}.welcom-mention1{height:32px;font-family:NanumBarunGothicOTF;font-size:28px;text-align:center;color:#000}.welcom-mention2{height:23px;font-family:NanumBarunGothicUltraLightOTF;font-weight:200;color:#c2c2c2}.welcom-mention2,.welcomNext{font-size:20px;text-align:center}.welcomNext{width:416px;height:64px;border-radius:3px;box-shadow:0 3px 10px 0 rgba(75,116,255,.6);background-color:#4b74ff;font-family:NanumBarunGothicOTF;color:#fff;margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2485f2fb","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LoginManager/Welcome.vue
// module id = 130
// module chunks = 0